export { default } from './CommentItem';



// WEBPACK FOOTER //
// ./src/components/Comment/CommentItem/index.js